












import ApiClient from '@/js/api.js'
import PopupTemplate from '@/views/templates/tenugui/PopupTemplate.vue'

export default
  components: {
    PopupTemplate
  }

  data: () ->
    point: 0

  created: () ->
    api = new ApiClient()
    param =
      'point_code': 'p2-1'
    data = await api.post('/member/point/save', true, param)
    @point = data.point
    if @point > 0
      @$emit('addPoint', @point)

  methods: {
    closePopup: () ->
      @$emit('closePopup')
  }
